import Reflux from "reflux";
import { SearchQuery } from "../datatypes/SearchResult";

export default {
    query: Reflux.createAction("query") as RefluxAction<[SearchQuery, number, Array<string>, string]>
};
